export default {
    namespaced: true,
    state: {
        listview_remain_flag: false,
        listview_remain_count: 0
    },
    mutations: {
        // 閲覧可能日数の情報をセット
        setListviewRemainInformation(state, listview_remain_information) {
            state.listview_remain_flag = listview_remain_information.listview_remain_flag ? listview_remain_information.listview_remain_flag : false;
            state.listview_remain_count = listview_remain_information.listview_remain_count ? listview_remain_information.listview_remain_count : 0;
        }
    },
    actions: {},
    getters: {
        // 閲覧可能日数の表示フラグを取得
        getListviewRemainFlag(state) {
            return state.listview_remain_flag;
        },
        // 閲覧可能日数を取得
        getListviewRemainCount(state) {
            return state.listview_remain_count;
        }
    }
}
